export const ReportIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="25" viewBox="0 0 20 25" fill="none">
    <path
      d="M17.0631 7.52634L9.99444 0.5L2.92581 7.52634C-0.975271 11.4041 -0.975271 17.7013 2.92581 21.5901C6.8269 25.4789 13.162 25.4678 17.0742 21.5901C20.9753 17.7123 20.9753 11.4151 17.0742 7.52634H17.0631ZM8.8608 21.4685V14.7184H5.47096L11.1281 5.72557V12.4757H14.5179L8.8608 21.4685Z"
      fill="black"
    />
  </svg>
);
